import { inherits as _inherits, createSuper as _createSuper, createClass as _createClass, classCallCheck as _classCallCheck } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import { TypedStorage } from './TypedStorage.mjs';

var NumberTypedStorage = /*#__PURE__*/function (_TypedStorage) {
  _inherits(NumberTypedStorage, _TypedStorage);

  var _super = _createSuper(NumberTypedStorage);

  function NumberTypedStorage() {
    _classCallCheck(this, NumberTypedStorage);

    return _super.apply(this, arguments);
  }

  _createClass(NumberTypedStorage, [{
    key: "increase",
    value: function increase() {
      var _this$get;

      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var value = (_this$get = this.get()) !== null && _this$get !== void 0 ? _this$get : 0;
      this.set(value + offset);
    }
  }, {
    key: "decrease",
    value: function decrease() {
      var _this$get2;

      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var value = (_this$get2 = this.get()) !== null && _this$get2 !== void 0 ? _this$get2 : 0;
      this.set(value - offset);
    }
  }]);

  return NumberTypedStorage;
}(TypedStorage);

export { NumberTypedStorage };
